import type { QueryObject } from 'ufo'
import type { ModuleOptions } from '../../types/module'
import type { ExtendedFetchOptions, ExtendedFetchUrl } from './fetch'
import { defu } from 'defu'
import { useRuntimeConfig } from 'nuxt/app'
import { joinURL, parseURL, withQuery } from 'ufo'
import { CONFIG_KEY } from '../config'
import { useBackendFetch } from './backend'

export function useSsoFetch<DataT>(
  url: ExtendedFetchUrl,
  options?: ExtendedFetchOptions<DataT>,
) {
  return useBackendFetch<DataT>(url, defu(options, {
    baseURL: (useRuntimeConfig().public[CONFIG_KEY] as ModuleOptions).sso.apiUrl,
  }))
}

interface UseSsoAppUrlOptions {
  path?: string
  query?: QueryObject
}

export function useSsoAppUrl() {
  return function (options?: UseSsoAppUrlOptions) {
    return withQuery(
      joinURL((useRuntimeConfig().public[CONFIG_KEY] as ModuleOptions).sso.appUrl, options?.path),
      options?.query,
    )
  }
}

export function isSsoAppUrl(url: string) {
  return parseURL(url).host === parseURL((useRuntimeConfig().public[CONFIG_KEY] as ModuleOptions).sso.appUrl).host
}
